// routing
import Routes from "routes";

// project imports
import NavigationScroll from "layout/NavigationScroll";
import RTLLayout from "ui-component/RTLLayout";
import Snackbar from "ui-component/extended/Snackbar";
import ThemeCustomization from "themes";

// auth provider
import { store } from "store";
import setAuthToken from 'Helpers/setAuthToken';

// ==============================|| APP ||============================== //

const App = () => {

  // if (localStorage.BDE_TOKEN) {
  //   setAuthToken(localStorage.BDE_TOKEN)
  // }


  return (
    <ThemeCustomization store={store}>
      {/* RTL layout */}
      <RTLLayout>
        <NavigationScroll>
          <>
            <Routes />
            <Snackbar />
          </>
        </NavigationScroll>
      </RTLLayout>
    </ThemeCustomization>
  );
};

export default App;
